import {useEffect, useState} from "react";
import {errMsg} from "@/components/cms/common";

export const UsersTab = ({call, me}) => {
  const [data, setData] = useState({roles: [], users: []});
  const load = () => call("get", "/users").then(setData);
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const change = async (uid, role) => { try { await call("patch", `/users/${uid}/role`, {role}); load(); } catch (e) { alert(errMsg(e)); } };
  return <div>
    <p className="muted">Siapa pun yang masuk dengan Google akan tercatat di sini. Beri peran <b>admin</b> agar dapat mengelola CMS.</p>
    <div className="cms-table">{data.users.map(u => <div className="cms-trow" key={u.user_id} data-testid={`cms-user-${u.email}`}>
      <span><b>{u.name || u.email}</b><small>{u.email}{u.user_id === me.user_id ? " · Anda" : ""}</small></span>
      <select data-testid={`cms-user-role-${u.email}`} value={u.role} onChange={e => change(u.user_id, e.target.value)}>{data.roles.map(r => <option key={r} value={r}>{r === "admin" ? "Admin CMS" : "Tanpa akses"}</option>)}</select>
    </div>)}</div>
  </div>;
};
